import { Component } from '@angular/core';
import { BaseDynamicLayoutHeaderComponent } from '@common-modules/dynamic-layout/base-dynamic-layout-header.component';

const COMPONENT_SELECTOR = 'tc-master-operator-group-toolbar';

@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './master-operator-group-toolbar.component.html',
    styleUrls: ['./master-operator-group-toolbar.component.scss'],
    standalone: false
})
export class MasterOperatorGroupToolbarComponent extends BaseDynamicLayoutHeaderComponent {}
